// src/Dashboard/pages/teacher/Belts/components/BeltsMobileCards.jsx

import React from "react";
import { FaHistory } from "react-icons/fa";

import {
  DEFAULT_BELT_PHOTO,
  DEFAULT_USER_PHOTO,
  formatDateFr,
  getAdherentGroupsLabel,
  getAdherentName,
  getAdherentPhoto,
  getCurrentBeltDate,
  getCurrentBeltImage,
  getCurrentBeltName,
} from "../utils/beltDashboardUtils";

export default function BeltsMobileCards({
  adherents = [],
  beltHistories = {},
  selectedIds,
  onToggleOne,
  onOpenDrawer,
}) {
  return (
    <div className="space-y-3 md:hidden">
      {adherents.map((adherent) => {
        const checked = selectedIds.has(adherent.id);
        const beltName = getCurrentBeltName(adherent.id, beltHistories);
        const beltImage = getCurrentBeltImage(adherent.id, beltHistories);
        const lastDate = getCurrentBeltDate(adherent.id, beltHistories);
        const groupsLabel = getAdherentGroupsLabel(adherent);

        return (
          <article
            key={`mobile-belt-${adherent.id}`}
            className={`overflow-hidden rounded-2xl border shadow-sm transition ${
              checked
                ? "border-indigo-300 bg-indigo-50 dark:border-indigo-500/30 dark:bg-indigo-500/10"
                : "border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900/60"
            }`}
          >
            <div className="p-4">
              <div className="flex items-start gap-3">
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={(event) =>
                    onToggleOne(adherent.id, event.target.checked)
                  }
                  className="mt-3 h-4 w-4 rounded border-slate-300"
                  aria-label={`Sélectionner ${getAdherentName(adherent)}`}
                />

                <img
                  src={getAdherentPhoto(adherent)}
                  alt={getAdherentName(adherent)}
                  onError={(event) => {
                    event.currentTarget.src = DEFAULT_USER_PHOTO;
                  }}
                  className="h-14 w-14 rounded-full object-cover ring-1 ring-slate-200 dark:ring-slate-700"
                />

                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-base font-bold text-slate-900 dark:text-white">
                    {getAdherentName(adherent) || "—"}
                  </h3>

                  <p className="mt-0.5 text-xs font-medium text-slate-500 dark:text-slate-400">
                    Saison {adherent?.saison_active || "—"} · Né(e) le{" "}
                    {formatDateFr(adherent.date_naissance)}
                  </p>

                  {groupsLabel ? (
                    <p className="mt-1 line-clamp-2 text-xs text-slate-500 dark:text-slate-400">
                      {groupsLabel}
                    </p>
                  ) : null}
                </div>
              </div>

              <div className="mt-4 rounded-2xl bg-slate-50 p-3 dark:bg-slate-800/50">
                <div className="flex items-center gap-3">
                  <img
                    src={beltImage}
                    alt={beltName || "Ceinture"}
                    onError={(event) => {
                      event.currentTarget.src = DEFAULT_BELT_PHOTO;
                    }}
                    className="h-8 w-fit object-contain"
                  />

                  <div>
                    <p className="text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400">
                      Ceinture actuelle
                    </p>

                    <p className="font-bold text-slate-900 dark:text-white">
                      {beltName || "—"}
                    </p>
                  </div>
                </div>

                <p className="mt-2 text-xs font-medium text-slate-500 dark:text-slate-400">
                  Dernier passage : {formatDateFr(lastDate)}
                </p>
              </div>

              <div className="mt-4 flex justify-end">
                <button
                  type="button"
                  onClick={() => onOpenDrawer(adherent)}
                  className="inline-flex items-center justify-center gap-2 rounded-xl bg-[#013E8E] px-3 py-2 text-xs font-bold text-white transition hover:bg-[#012f6c]"
                >
                  <FaHistory />
                  Historique
                </button>
              </div>
            </div>
          </article>
        );
      })}
    </div>
  );
}